export default "__VITE_ASSET__Cz1m2D7b__"